import { FormattedMessage } from 'react-intl';

import { Alert } from '@app/components/Alert';
import type { AlertType } from '@app/components/Alert/Alert.constants';
import { rem } from '@app/styles/theme/layout';

import messages from '../ReturnRequest.messages';

export type ReturnRequestAlertType = Exclude<
  AlertType,
  AlertType.Warning
> | null;

export function ReturnRequestAlerts({
  alert,
}: {
  alert: ReturnRequestAlertType;
}) {
  if (!alert) return null;

  return (
    <div style={{ marginBottom: rem(28) }}>
      <Alert type={alert}>
        {alert === 'success' ? (
          <FormattedMessage {...messages.returnRequestSuccess} />
        ) : alert === 'error' ? (
          <FormattedMessage {...messages.returnRequestError} />
        ) : (
          <FormattedMessage {...messages.returnRequestInfo} />
        )}
      </Alert>
    </div>
  );
}
